// extracted by mini-css-extract-plugin
export default {"img_project":"PortfolioBlock_img_project__m+hAE"};